import type { KeyedMutator } from 'swr';

import type { PageInfo } from '../../../model/PageInfo';

export class Response<T> {
  constructor(
    public data: T | undefined,
    public pageInfo: PageInfo | undefined,
    public loading: boolean,
    public error: Error | undefined,
    public mutate?: KeyedMutator<T>,
  ) {}

  /**
   * `fromEnvelope` says whether `resp` is a `{ data, pageInfo }` envelope; the caller
   * that produced it knows. Inferring it from the presence of a `data` key would
   * unwrap any entity that happens to carry one.
   */
  static buildResponse<T>(
    resp: any,
    fromEnvelope: boolean,
    error: Error | undefined,
    isLoading: boolean,
    mutate?: KeyedMutator<T>,
  ) {
    const data: T | undefined = fromEnvelope ? resp?.data : resp;
    const pageInfo = fromEnvelope ? resp?.pageInfo : undefined;

    return new Response<T>(data, pageInfo, isLoading, error, mutate);
  }
}
